(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-landing"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polypouch-stock-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slugify = (value) => value.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

    const csvCell = (value) => `"${String(value || '').replace(/"/g, '""')}"`;

    const initialise = async (root) => {
      if (root.dataset.stockInitialised === 'true') return;
      root.dataset.stockInitialised = 'true';
      root.setAttribute('aria-busy', 'true');

      const source = root.querySelector('[data-stock-source]');
      const sourceTable = root.querySelector('[data-stock-source-table]');
      const sourceWrap = root.querySelector('[data-stock-source-table-wrap]');
      const pagination = root.querySelector('[data-stock-pagination]');
      if (!source || !sourceTable || !sourceWrap) return;

      let nextUrl = source.dataset.nextUrl;
      let allPagesLoaded = true;
      const ids = new Set([...sourceTable.querySelectorAll('[data-stock-row]')].map((row) => row.dataset.lineId));

      while (nextUrl) {
        try {
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', root.dataset.sectionId);
          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error(String(response.status));
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const fetchedRoot = documentFragment.querySelector('[data-stock-list-section]');
          const fetchedSource = fetchedRoot?.querySelector('[data-stock-source]');
          const fetchedRows = fetchedRoot?.querySelectorAll('[data-stock-row]') || [];
          fetchedRows.forEach((row) => {
            if (!ids.has(row.dataset.lineId)) {
              ids.add(row.dataset.lineId);
              sourceTable.tBodies[0].append(row);
            }
          });
          nextUrl = fetchedSource?.dataset.nextUrl || '';
        } catch (error) {
          allPagesLoaded = false;
          break;
        }
      }

      const rows = [...sourceTable.querySelectorAll('[data-stock-row]')];
      const groupsContainer = root.querySelector('[data-stock-groups]');
      const groupNav = root.querySelector('[data-stock-group-nav]');
      const search = root.querySelector('[data-stock-search]');
      const type = root.querySelector('[data-stock-type]');
      const status = root.querySelector('[data-stock-status]');
      const reset = root.querySelector('[data-stock-reset]');
      const empty = root.querySelector('[data-stock-empty]');
      const preferred = (root.dataset.groupOrder || '').split('||').map((item) => item.trim()).filter(Boolean);
      const groupNames = [...new Set(rows.map((row) => row.dataset.group))];
      const isAccessoryGroup = (name) => /accessor|heat sealer|funnel/i.test(name);
      const pouchGroups = groupNames.filter((name) => !isAccessoryGroup(name));
      const accessoryGroups = groupNames.filter(isAccessoryGroup);
      const orderedGroups = [
        ...preferred.filter((name) => pouchGroups.includes(name)),
        ...pouchGroups.filter((name) => !preferred.includes(name)).sort((a, b) => a.localeCompare(b)),
        ...preferred.filter((name) => accessoryGroups.includes(name)),
        ...accessoryGroups.filter((name) => !preferred.includes(name)).sort((a, b) => a.localeCompare(b))
      ];

      orderedGroups.forEach((groupName, index) => {
        const option = document.createElement('option');
        option.value = groupName;
        option.textContent = groupName;
        type.append(option);

        const section = document.createElement('section');
        section.className = 'pp-stock-list__group';
        section.id = `${root.dataset.sectionId}-${slugify(groupName)}`;
        section.dataset.stockGroup = groupName;

        const header = document.createElement('header');
        header.className = 'pp-stock-list__group-head';
        const titleWrap = document.createElement('div');
        titleWrap.className = 'pp-stock-list__group-title';
        const number = document.createElement('span');
        number.className = 'pp-stock-list__group-number';
        number.setAttribute('aria-hidden', 'true');
        number.textContent = String(index + 1);
        const heading = document.createElement('h3');
        heading.textContent = groupName;
        titleWrap.append(number, heading);
        const count = document.createElement('span');
        count.className = 'pp-stock-list__group-count';
        count.dataset.stockGroupCount = '';
        header.append(titleWrap, count);

        const scroll = document.createElement('div');
        scroll.className = 'pp-stock-list__table-scroll';
        const table = document.createElement('table');
        table.className = 'pp-stock-list__table';
        table.append(sourceTable.tHead.cloneNode(true));
        const body = document.createElement('tbody');
        rows.filter((row) => row.dataset.group === groupName).forEach((row) => body.append(row));
        table.append(body);
        scroll.append(table);
        section.append(header, scroll);
        groupsContainer.append(section);

        const navLink = document.createElement('a');
        navLink.href = `#${section.id}`;
        navLink.dataset.stockGroupLink = groupName;
        groupNav.append(navLink);
      });

      sourceWrap.hidden = true;
      if (allPagesLoaded && pagination) pagination.hidden = true;

      const update = () => {
        const query = search.value.trim().toLowerCase();
        let visible = 0;
        let inStock = 0;
        let lowStock = 0;
        let outOfStock = 0;

        rows.forEach((row) => {
          const matchesQuery = !query || row.dataset.search.includes(query);
          const matchesType = type.value === 'all' || row.dataset.group === type.value;
          const matchesStatus = status.value === 'all' || row.dataset.status === status.value;
          const show = matchesQuery && matchesType && matchesStatus;
          row.hidden = !show;
          row.dataset.visible = String(show);
          if (show) {
            visible += 1;
            if (row.dataset.status === 'in-stock') inStock += 1;
            if (row.dataset.status === 'low-stock') lowStock += 1;
            if (row.dataset.status === 'out-of-stock') outOfStock += 1;
          }
        });

        root.querySelectorAll('[data-stock-group]').forEach((section) => {
          const groupRows = [...section.querySelectorAll('[data-stock-row]')];
          const groupVisible = groupRows.filter((row) => !row.hidden).length;
          section.hidden = groupVisible === 0;
          const count = section.querySelector('[data-stock-group-count]');
          count.textContent = String(groupVisible);
          const link = root.querySelector(`[data-stock-group-link="${CSS.escape(section.dataset.stockGroup)}"]`);
          if (link) {
            link.hidden = groupVisible === 0;
            link.textContent = `${section.dataset.stockGroup} (${groupVisible})`;
          }
        });

        root.querySelector('[data-stock-visible]').textContent = String(visible);
        root.querySelector('[data-stock-in]').textContent = String(inStock);
        root.querySelector('[data-stock-low]').textContent = String(lowStock);
        root.querySelector('[data-stock-out]').textContent = String(outOfStock);
        root.querySelector('[data-stock-result]').textContent = `${visible} active ${visible === 1 ? 'line' : 'lines'}`;
        empty.hidden = visible !== 0;
      };

      const download = () => {
        const visibleRows = rows.filter((row) => row.dataset.visible === 'true');
        const headers = root.dataset.csvHeaders.split('||');
        const records = visibleRows.map((row) => [
          row.dataset.product,
          row.dataset.size,
          row.dataset.sku,
          row.dataset.group,
          row.dataset.material,
          row.dataset.features,
          row.dataset.price,
          row.dataset.stockLabel,
          row.dataset.productUrl
        ]);
        const csv = `\uFEFF${[headers, ...records].map((record) => record.map(csvCell).join(',')).join('\r\n')}`;
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = root.dataset.csvFilename;
        document.body.append(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
      };

      search.addEventListener('input', update);
      type.addEventListener('change', update);
      status.addEventListener('change', update);
      reset.addEventListener('click', () => {
        search.value = '';
        type.value = 'all';
        status.value = 'all';
        update();
        search.focus();
      });
      root.querySelector('[data-stock-download]').addEventListener('click', download);
      root.stockListDownload = download;
      root.removeAttribute('aria-busy');
      update();
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-stock-list-section]').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="#download-stock-list"]');
      if (!trigger) return;
      const root = document.querySelector('[data-stock-list-section]');
      if (!root?.stockListDownload) return;
      event.preventDefault();
      root.stockListDownload();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
